/*
 * ebook-download
 * Dispara o evento de conversão no GA4 quando o lead abre o e-book.
 * Espelha o generate_lead que assets/lead-form-revi.js dispara no cadastro.
 *
 * O link é cross-origin (cdn.shopify.com), então o atributo download é
 * ignorado pelo navegador — por isso o CTA abre em nova aba em vez de baixar.
 */

class EbookDownload extends HTMLElement {
  connectedCallback() {
    this.cta = this.querySelector('[data-ebook-cta]');
    if (!this.cta || this.cta.getAttribute('aria-disabled') === 'true') return;

    this.cta.addEventListener('click', () => {
      if (typeof window.gtag !== 'function') return;

      window.gtag('event', 'file_download', {
        file_name: this.dataset.fileName || 'ebook',
        link_url: this.cta.href || '',
        source_id: this.dataset.sourceId || 'ebook-page',
        send_to: 'G-YFLTWWFDJW',
      });
    });
  }
}

if (!customElements.get('ebook-download')) {
  customElements.define('ebook-download', EbookDownload);
}
